import ControllerBase from '../../../../global/js/ControllerBase';
import { fromEvent } from 'rxjs';
import { AtomFabButtonEvents, AtomFabButtonEventTypes } from './a-fab-button.events';
import { OrganismFabMenuEvents, OrganismFabMenuEventTypes } from 'wolf/components/organisms/o-fab-menu/o-fab-menu.events';

interface ComponentRefs {
	fabAnchor: 'fabAnchor',
}

export default class ControllerFabButton extends ControllerBase<ComponentRefs> {

	private readonly fabAnchor: HTMLAnchorElement;
	private readonly openClass = 'open';

	constructor(element: HTMLElement) {
		super(element);

		this.fabAnchor = this.$references.fabAnchor as HTMLAnchorElement;
		if (this.fabAnchor) {
			// watch for fab button clicks
			this.observeButtonClick();
			this.observeMenuToggling();
		}
	}

	/**
	 * Observe button clicks and emit menu trigger event
	 */
	private observeButtonClick(): void {

		fromEvent(this.fabAnchor, 'click')
		.subscribe((e: Event | MouseEvent) => {
			e.preventDefault();

			this.dispatchCustomEvent<
				AtomFabButtonEventTypes['buttonClicked']
			>(AtomFabButtonEvents.buttonClicked, e, true, true);

		});
	}

	/**
	 * Observe the menu being opened by the organism and update the button state to reflect the menu state
	 * @returns void
	 */
	private observeMenuToggling(): void {

		fromEvent<CustomEvent<OrganismFabMenuEventTypes>>(window, OrganismFabMenuEvents['menuIsOpen'])
		.subscribe((e) => {

			// connect the open state of the fab button to reflect the open state of the menu
			if (e.detail.menuIsOpen) {
				this.toggleOpenState('open');
			} else {
				this.toggleOpenState('closed');
			}

		});
	}

	/**
	 * Add/remove a class to show the button in the open/closed state
	 * @param  {'open'|'closed'} setOpenState
	 * @returns void
	 */
	private toggleOpenState(setOpenState: 'open' | 'closed'): void {

		if (setOpenState === 'open') {
			this.fabAnchor.classList.contains('open') === false ? this.fabAnchor.classList.add(this.openClass) : undefined;
		} else if (setOpenState === 'closed') {
			this.fabAnchor.classList.contains('open') === true ? this.fabAnchor.classList.remove(this.openClass) : undefined;
		}
	}

}
